import Seo from "@/components/Seo";
import { organizationJsonLd, websiteJsonLd } from "@/lib/seo";

export default function TestDashboard() {
  return (
    <div className="min-h-screen bg-blue-50 p-8">
      <Seo
        title="Test Dashboard | Travel Wings Global"
        description="Internal test dashboard."
        path="/test-dashboard"
        structuredData={[organizationJsonLd, websiteJsonLd]}
        noindex
      />
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow p-6">
          <h1 className="text-3xl font-bold text-blue-900 mb-4">🧪 Test Dashboard</h1>
          <div className="space-y-4">
            <div className="bg-green-100 p-4 rounded">
              <h2 className="font-semibold text-green-800">✅ Component Loaded Successfully</h2>
              <p className="text-green-700">This test dashboard is working on Vercel!</p>
            </div>
            <div className="bg-blue-100 p-4 rounded">
              <h2 className="font-semibold text-blue-800">🔧 Debug Information</h2>
              <p className="text-blue-700">Window location: {typeof window !== 'undefined' ? window.location.href : 'Server side'}</p>
              <p className="text-blue-700">Environment: {import.meta.env.MODE}</p>
            </div>
            <div className="bg-yellow-100 p-4 rounded">
              <h2 className="font-semibold text-yellow-800">🔐 Authentication Test</h2>
              <p className="text-yellow-700">Token exists: {typeof window !== 'undefined' ? (localStorage.getItem('authToken') ? 'Yes' : 'No') : 'Server side'}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}